import React from 'react';

import { useNotFoundPageProviderContext } from '@common/react/components/Core/NotFoundPageProvider/NotFoundPageProvider';

interface Props {
	defaultNotFoundComponent?: JSX.Element;
}

const NotFoundComponent: React.FC<Props> = (props: Props) => {
	const { defaultNotFoundComponent } = props;
	const notFoundComponentContext = useNotFoundPageProviderContext();

	return notFoundComponentContext?.state?.notFoundPage || defaultNotFoundComponent || '';
};

export default NotFoundComponent;
